(function () {
   let pageTypeContainer = $$('[data-active-page-type]');
   let pageTypeDiv = $$('[data-page-type]');

   // In order to keep tab focus functionality working with a differing click event functionality,
   // we need to track whether the user has clicked on the page type form or not. This variable will
   // keep track of this so we can still use setActivePageType() and track that we previously clicked
   // on the page type form. This will also allow us to reset the highlighting when switching to using
   // tab focusing without skipping objects to tab focus on.
   let clickActivePageType = '';

   pageTypeDiv.addEvents({
      'keydown:keys(tab)': function () {
         clickActivePageType = '';
      },
      click: function () {
         const pageType = this.getProperty('data-page-type');
         if (clickActivePageType == '') {
            clickActivePageType = pageType;
            setActivePageType(pageType);
            document.querySelector(`.title-input-${pageType}`)?.focus();
            return;
         }
         if (clickActivePageType !== pageType) {
            resetActivePageType();
            return;
         }
      },
      focusin: function () {
         if (clickActivePageType == '') {
            const pageTypeDiv = findParent(document.activeElement, 'data-page-type');
            if (pageTypeDiv) {
               setActivePageType(pageTypeDiv.getProperty('data-page-type'));
            }
         }
      },
   });

   window.addEvents({
      click: function (event) {
         if (event.target.getParent('[data-page-type]')) {
            return;
         }

         resetActivePageType();
      },
      'keydown:keys(esc)': function () {
         resetActivePageType();
      },
      focusin: function (event) {
         let pageTypeElement = event.target.getParent().closest('.page-type-container');
         if (!pageTypeElement) {
            resetActivePageType();
         }
      },
   });

   function setActivePageType(pageType) {
      document.body.setStyle('cursor', 'pointer');

      pageTypeContainer.setProperty('data-active-page-type', pageType);
   }

   function resetActivePageType() {
      clickActivePageType = '';
      document.body.setStyle('cursor', 'auto');

      pageTypeContainer.setProperty('data-active-page-type', '');
   }

   function findParent(element, property) {
      if (element.getProperty(property)) {
         return element;
      }
      return element.getParent(`[${property}]`);
   }
})();
